/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBadgeUp = createReactComponent("arrow-badge-up", "IconArrowBadgeUp", [
  ["path", { d: "M17 11v6l-5 -4l-5 4v-6l5 -4z", key: "svg-0" }]
]);

export { IconArrowBadgeUp as default };
//# sourceMappingURL=IconArrowBadgeUp.js.map
